module.exports = __webpack_public_path__ + "static/img/IP-img2.42d649e4.png";